/** The image worker started from its bundle under the app's Trusted Types policy (part 16a, I2; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { ImageWorker } from './importer.ts';

/** T6, T7: a function starting an image worker (a module worker) for each image (decision 56: one per import). */
export function imageWorker(source: WorkerSource<ImageWorker>): () => ImageWorker {
  return () => new source.Worker(source.trusted(source.url), { type: 'module', name: 'images' });
}
